/**
 * Stable `event.source` for WTC Email (next-email-client) calendar events.
 * Must stay in sync with calendar-context filtering when the user's Hub email is selected.
 */
export const WTC_EMAIL_CALENDAR_SOURCE_ID = "wtc-email-calendar";

/** @deprecated prefer WTC_EMAIL_CALENDAR_SOURCE_ID */
export const LEGACY_WTC_EMAIL_CALENDAR_SOURCE_ID = "professional-email-calendar";

export function formatWtcEmailCalendarSourceForDisplay(source: string): string {
  if (
    source === WTC_EMAIL_CALENDAR_SOURCE_ID ||
    source === LEGACY_WTC_EMAIL_CALENDAR_SOURCE_ID
  ) {
    return "WTC Email (mail)";
  }
  return source;
}
